import axios from 'axios';
import Vue from 'vue';
import store from '@/plugins/store/index'
import Message from '../../components/app/classes/Message';

// const jwt = require('jsonwebtoken');

export default {
    axiosInstance: null,
    requestInterceptor: config => {
        //TODO: ADD VERIFICATION SESSION
        return config;
    },
    responseInterceptor: response => {
        return response;
    },
    responseErrorInterceptor: error => {
        //INVALID_AUTH_TOKEN
        // console.log('error', error);

        let code = Math.floor(error.request.status / 100);
        let title, message;
        if (code == 4) {
            title = "No Autorizado";
            if (error.request.status == 401) {
                message = "Usuario no autorizado.";
            }
        } else if (code == 5) {
            title = "Recurso no disponible";
            message = error.message;
        }
        store.commit("app/reportMessage", new Message('$error', title, message, "Cancelar", "OK", () => {
            console.log("Cancelar")
        }));
        return Promise.reject(error);
    },
    //{"security":{"jwt":"eyJhbGciOiJIUzI1NiJ9.eyJpZCI6IjYxOTU0OWUyY2QwMDQyNjdkMWU2MjUzNSIsImV4cCI6MTYzNzI2Njc5N30.O6OHQvc0-BXz6cdE7RCF-QdgZ28rXrEICAhsiyK-lOU"}}
    setHeader(token) {
        this.axiosInstance.defaults.headers.common['Authorization'] = token;
        // const tk = jwt.sign({id: '61ce0d2dece3d76223dedd67'}, process.env.JWT_SECRET);
        // console.log('tk', tk);
        console.log("OK")
    },
    init() {
        this.axiosInstance = axios.create({});
        this.axiosInstance.interceptors.request.use(this.requestInterceptor, function (error) {
            console.log(error);
            store.commit("app/reportMessage", new Message('$error', "Recurso no disponible", error.message, "Cancelar", "OK"));
        });
        this.axiosInstance.interceptors.response.use(this.responseInterceptor, this.responseErrorInterceptor);
        //this.setHeader("TOKEN"); TODO: TO DEFINE WHO PROVIDE THE TOKEN OR COOKIE SESSION
        Vue.prototype.$axios = this.axiosInstance;
    }
};